module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "landing-office"
  }, [_c('section', {
    staticClass: "office-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "inner-container office-container"
  }, [_c('h1', {
    staticClass: "section-title"
  }, [_vm._v("Escritório lindo novinho e acessível")]), _vm._v(" "), _c('p', {
    staticClass: "section-subtitle"
  }, [_vm._v("Um escritório incrível localizado no coração da Faria Lima, localizado em um dos melhores bairros de SP,\n     rodeado por bons restaurantes.")]), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('img', {
    staticClass: "office-image",
    attrs: {
      "src": require("../assets/images/geral.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "office-section-about md-col-12 col-4"
  }, [_c('h4', [_vm._v("Open Space + HotDesking")]), _vm._v(" "), _c('p', [_vm._v("Não temos lugar fixo. Acreditamos que um espaço aberto favorece a colaboração entre os funcionários do Moip e otimiza o uso do espaço do escritório.")])]), _vm._v(" "), _c('div', {
    staticClass: "office-section-about md-col-12 col-4"
  }, [_c('h4', [_vm._v("Prezamos pela informalidade")]), _vm._v(" "), _c('p', [_vm._v("É possível ser sério sem ser mal-humorado ou vestir um terno; é possível trabalhar muito sendo alegre; é possível falar com respeito usando gírias. Sabemos que você é um adulto ;)")])]), _vm._v(" "), _c('div', {
    staticClass: "office-section-about md-col-12 col-4"
  }, [_c('h4', [_vm._v("Também gostamos de descanso e diversão")]), _vm._v(" "), _c('p', [_vm._v("Trabalhamos sério e duro, mas é exatamente por isso que reconhecemos a importância de uma paradinha para a recarga das baterias.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35dac51f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingOffice.vue
// module id = 136
// module chunks = 1